import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueLazyload from 'vue-lazyload'

Vue.use(VueLazyload, {
  preLoad: 1.3,
  loading: 'static/srbanner/1.gif',
  attempt: 1
})
// 配置 ElementUI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);



// 配置 全局初始化样式  @代表src目录
import '@/assets/css/reset.scss';

Vue.config.productionTip = false

//工具
import '@/utils/mixins.js'

// Vue.prototype.$ = $; // 当然还有这句话 给vue原型上添加 $

new Vue({
  router,
  store,
  render: h => h(App),

}).$mount('#app')
